import type { RefObject } from 'react'

export type RefOrEl<E> = RefObject<E | null> | E | null

export const normalizeToEl = <E>(refOrEl?: RefOrEl<E>): E | null => {
  if (!refOrEl) return null
  return typeof refOrEl === 'object' && 'current' in refOrEl ? refOrEl.current : refOrEl
}
